module.exports = __webpack_public_path__ + "static/media/Products (6).340d1102.png";